import React, { useState } from 'react';
import { withStyles } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import Divider from '@material-ui/core/Divider';
import { Link } from 'react-router-dom';
import DataService from '../../../services/DataService';
import { useNotificationContext } from '../../../services/NotificationService';
import styles from './styles';

const AdminMenu = (props) => {
  const { classes } = props;
  let { page } = props;
  const notifications = useNotificationContext();
  const [isRefreshing, setIsRefreshing] = useState(false);

  const handleRefreshKnowledge = () => {
    setIsRefreshing(true);
    notifications.dispatch({
      type: 'DISPLAY_ALERT',
      payload: {
        message: 'Agent knowledge refresh started. This may take a few minutes.',
        severity: 'info',
      },
    });
    DataService.RefreshAgentKnowledge()
      .then((response) => {
        notifications.dispatch({
          type: 'DISPLAY_ALERT',
          payload: {
            message: 'Agent knowledge refresh completed successfully.',
            severity: 'success',
          },
        });
      })
      .catch((error) => {
        notifications.dispatch({
          type: 'DISPLAY_ALERT',
          payload: {
            message: error?.response?.data?.detail || 'Agent knowledge refresh failed.',
            severity: 'error',
          },
        });
      })
      .finally(() => {
        setIsRefreshing(false);
      });
  };

  return (
    <div className={classes.adminMenuContainer}>
      <MenuList>
        <MenuItem selected={page == 'solutionsdashboard'} component={Link} to="/admin/solutionsdashboard">Solutions Dashboard</MenuItem>
        <Divider />
        <MenuItem selected={page == 'equations'} component={Link} to="/admin/equations">Equations</MenuItem>
        <Divider />
        <MenuItem selected={page == 'usecases'} component={Link} to="/admin/usecases">Use Cases</MenuItem>
        <Divider />
        <MenuItem selected={page == 'featuredsolutions'} component={Link} to="/admin/featuredsolutions">Featured Solutions</MenuItem>
        <Divider />
        <MenuItem selected={page == 'users'} component={Link} to="/admin/users">Users</MenuItem>
        <Divider />
        <MenuItem onClick={handleRefreshKnowledge} disabled={isRefreshing}>
          {isRefreshing ? 'Refreshing Knowledge...' : 'Refresh Knowledge'}
        </MenuItem>
        <Divider />
      </MenuList>
    </div>
  );
};

export default withStyles(styles)(AdminMenu);